export const newOperations = {
  state: {
    list: [],
    generalDescription: 'Ручная операция',
    operationType: 'arrivals',
    searchCriterion: 'name',
  },
  getters: {
    prepareListForApi: (state) => {
      const preparedList = state.list.map((operation) => {
        const { id, count, name, type, operation_description } = operation;
        const returningValue =  {
          id,
          name,
          type,
          new_value: count,
          operation_description: operation_description
            || state.generalDescription,
        }
        if (type === 'продукт') {
          returningValue.parent_id = operation.parent_id;
        }
        if (state.operationType === 'transfer') {
          const { current_user, transferrer } = operation;
          returningValue.current_user_id = current_user.id;
          returningValue[transferrer.foreign_key] = transferrer.id;
        }
        return returningValue;
      });
      return preparedList;
    },
  },
  mutations: {
    changeSearchCriterion(state, value) {
      state.searchCriterion = value;
    },
    changeOperationType(state, value) {
      state.operationType = value;
    },
    changeDescription(state, value) {
      state.generalDescription = value;
    },
    addItemInList(state, item = []) {
      state.list.push(item);
    },
    editItemInList(state, item = []) {
      const results = state.list.map((existedItem) => {
        const areEqual = existedItem.listHash === item.listHash;
        if (areEqual) {
          existedItem = JSON.parse(JSON.stringify(item));
        }
        return existedItem;
      });
      state.list = results;
    },
    removeItemFromList(state, item = []) {
      const results = state.list.filter((existedItem) => (
        existedItem.listHash !== item.listHash
      ));
      state.list = results;
    },
    clearList(state) {
      state.list = [];
    },
  },
  actions: {
    setSearchCriterion(context, value = 'name') {
      const possibleValues = ['name', 'type', 'vendor_code', 'barcode'];
      if (possibleValues.includes(value)) {
        context.commit('changeSearchCriterion', value);
      }
    },
    setOperationType(context, value = 'arrivals') {
      const possibleValues = [
        'arrivals','expenses', 'write_offs', 'transfer',
      ];
      if (possibleValues.includes(value)) {
        context.commit('changeOperationType', value);
      }
    },
    setGeneralDescription(context, value = '') {
      if (!value) {
        value = 'Ручная операция';
      }
      context.commit('changeDescription', value);
    },
    add(context, item = []) {
      context.commit('addItemInList', item);
    },
    edit(context, item = []) {
      context.commit('editItemInList', item);
    },
    remove(context, item = []) {
      context.commit('removeItemFromList', item);
    },
    clear(context) {
      context.commit('clearList');
    },
  },
};



// WEBPACK FOOTER //
// ./src/stock/store/new-operations.js